import { request } from '@/shared/api/request'

export const getPhoneAndConsent = (iin, bin, fullName) => {
	return request({
		url: `/proactive/getPhoneAndConsent?iin=${iin}&bin=${bin}&fullName=${fullName}`,
		method: 'POST',
	})
}
